class FindInStorePanel extends window.SlideOutPanel {
  get openTriggerSelector() {
    return '[data-find-in-store]';
  }

  onConnected() {
    this.storeInfoPage = this.dataset.storeInfoPage;
    this.sizeSelector = document.getElementById('store-availability-size');
    this.variantRadios = document.querySelectorAll('input[name="Size"]');
    this.variantSelects = document.querySelectorAll('variant-selects select');
    this.locations = [];
    this.locationsLoaded = false;

    this.updateFindInStoreVisibility();

    this.variantSelects.forEach((select) => {
      select.addEventListener('change', () => this.updateFindInStoreVisibility());
    });

    document.addEventListener('jtcVariantLocationsLoaded', (event) => {
      this.locations = event.detail.locations;
      this.locationsLoaded = true;
      this.updateFindInStoreVisibility();
      this.updateFindInStoreButton();
      this.renderStores(event.detail.variantID);
    });

    if (this.sizeSelector) {
      this.sizeSelector.addEventListener('change', () => {
        const selectedText = this.sizeSelector.selectedOptions[0]?.textContent?.trim();
        if (!selectedText) return;

        this.variantRadios.forEach((radio) => {
          if (radio.value === selectedText) {
            radio.nextElementSibling.click();
          }
        });

        this.variantSelects.forEach((select) => {
          const matchingOption = Array.from(select.options).find((option) => option.value === selectedText);
          if (matchingOption) {
            select.value = matchingOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }

  isVariantSelected() {
    if (!this.variantSelects?.length) return true;
    return Array.from(this.variantSelects).every((select) => select.value !== '');
  }

  updateFindInStoreVisibility() {
    const selected = this.isVariantSelected();
    document.querySelectorAll('[data-find-in-store-wrapper]').forEach((wrapper) => {
      wrapper.hidden = !selected;
    });
  }

  updateFindInStoreButton() {
    const buttons = document.querySelectorAll('[data-find-in-store]');
    const locations = Array.isArray(this.locations) ? this.locations : [];
    const inStockStores = locations.filter((location) => location.enabled && location.stock > 0);

    buttons.forEach((button) => {
      const indicator = button.querySelector('[data-find-in-store-indicator]');
      const label = button.querySelector('[data-find-in-store-label]');
      const extra = button.querySelector('[data-find-in-store-extra]');
      if (!indicator || !label || !extra) return;

      const availableLabel = button.dataset.labelAvailable || 'Available in store';
      const unavailableLabel = button.dataset.labelUnavailable || 'Not available in store';
      const storeOneTemplate = button.dataset.labelStoreOne || '__COUNT__ store';
      const storeOtherTemplate = button.dataset.labelStoreOther || '__COUNT__ stores';

      if (!this.locationsLoaded || inStockStores.length === 0) {
        indicator.classList.remove('find-in-store-btn__indicator--in-stock');
        label.textContent = unavailableLabel;
        extra.textContent = '';
        extra.classList.add('tw-hidden');
        return;
      }

      indicator.classList.add('find-in-store-btn__indicator--in-stock');
      label.textContent = availableLabel;

      const count = inStockStores.length;
      const template = count === 1 ? storeOneTemplate : storeOtherTemplate;
      extra.textContent = template.replace('__COUNT__', String(count));
      extra.classList.remove('tw-hidden');
    });
  }

  renderStores(variantID = '') {
    const storesList = document.getElementById('find-in-store-stores-list');
    if (!storesList) return;

    if (!this.locations || this.locations.length === 0) {
      storesList.innerHTML = '<div class="find-in-store-panel__loading | tw-text-center | tw-py-8"><p class="font-body | tw-text-primary_mid_grey | tw-m-0">No stores found with this product in stock.</p></div>';
      return;
    }

    if (variantID !== '' && this.sizeSelector) {
      this.sizeSelector.value = variantID;
    }

    storesList.innerHTML = '';

    this.locations.forEach((location) => {
      if (!location.enabled) return;

      const templateNode = document.importNode(document.getElementById('find-a-store-item').content, true)?.children[0];
      templateNode.querySelector('.find-in-store-panel__store-name').textContent = location.name;
      templateNode.querySelector('.find-in-store-panel__size').textContent = `Size: ${this.sizeSelector?.selectedOptions[0]?.textContent || ''}`;
      templateNode.querySelector('.find-in-store-panel__store-address').textContent = `${location.address1}, ${location.city} ${location.zip}`;
      templateNode.querySelector('.find-in-store-panel__store-info').innerHTML = `
        <a target="_blank" href="${this.storeInfoPage || '#'}" class="tw-text-primary_mid_grey tw-block full-unstyled-link">Store info</a>
      `;

      const stockStatus = templateNode.querySelector('.find-in-store-panel__stock-status');
      stockStatus.querySelectorAll(':scope > *').forEach((node) => {
        node.classList.add('tw-hidden');
      });
      stockStatus.querySelectorAll(`[${location.stock > 0 ? 'in-stock' : 'sold-out'}]`).forEach((node) => {
        node.classList.remove('tw-hidden');
      });

      storesList.appendChild(templateNode);
    });
  }
}

if (!customElements.get('find-in-store-panel')) {
  customElements.define('find-in-store-panel', FindInStorePanel);
}
